import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";

const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_6f589b7c-cf0b-4735-b26a-4f9ad45f8238/artifacts/3skh2mwe_Logo_Para_Aplicar_sobre_Fondo_Oscuro.png.png";

export default function Footer() {
  return (
    <footer className="bg-primary text-white mt-auto hidden md:block" data-testid="main-footer">
      <div className="relative industrial-texture"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & About */}
          <div className="space-y-4">
            <img src={LOGO_DARK_BG} alt="Barraca Maldonado" className="h-12" />
            <p className="text-white/80 text-sm">
              Una de las barracas más grandes e importantes de Uruguay. Materiales de construcción, herramientas y electrodomésticos.
            </p>
            <p className="text-white/60 text-sm font-heading tracking-wider">
              "GENTE QUE CUMPLE"
            </p>
          </div>

          {/* Contact - Barraca */}
          <div>
            <h3 className="font-heading text-lg mb-4 tracking-wide">BARRACA</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Lun a Vie: 7:30 a 18:30</p>
                  <p>Sábados: 7:30 a 13:00</p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:42236718" className="hover:text-white/80">4223 6718</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#25D366]" />
                <a href="https://wa.me/59899179773" className="hover:text-white/80">099 179 773</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:ventas@barracamaldonado.com.uy" className="hover:text-white/80 break-all">
                  ventas@barracamaldonado.com.uy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact - Electrodomésticos */}
          <div>
            <h3 className="font-heading text-lg mb-4 tracking-wide">ELECTRODOMÉSTICOS</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Lun a Vie: 9:00 a 18:30</p>
                  <p>Sábados: 8:00 a 13:00</p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#25D366]" />
                <a href="https://wa.me/59898546464" className="hover:text-white/80">098 546 464</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:electrodomesticos@barracamaldonado.com.uy" className="hover:text-white/80 break-all text-xs">
                  electrodomesticos@barracamaldonado.com.uy
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg mb-4 tracking-wide">ENLACES</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/tienda" className="hover:text-white/80">Tienda</Link>
              </li>
              <li>
                <Link to="/calculadora" className="hover:text-white/80">Calculadora de Materiales</Link>
              </li>
              <li>
                <Link to="/comparador" className="hover:text-white/80">Comparador</Link>
              </li>
              <li>
                <Link to="/mi-cuenta" className="hover:text-white/80">Mi Cuenta</Link>
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://facebook.com/barracamaldonado"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white/80"
                aria-label="Facebook"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a
                href="https://instagram.com/barracamaldonado"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white/80"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/20 mt-8 pt-8 text-sm text-white/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <p>© {new Date().getFullYear()} Barraca Maldonado. Todos los derechos reservados.</p>
              <p className="mt-1">Precios expresados en USD, IVA incluido.</p>
            </div>
            
            <div className="flex items-center gap-4">
              {/* Propuesta access - very subtle, just an icon */}
              <Link 
                to="/propuesta" 
                className="text-white/20 hover:text-white/50 transition-colors"
                title="•"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </Link>
              
              {/* Admin access - subtle */}
              <Link 
                to="/admin" 
                className="flex items-center gap-2 text-white/40 hover:text-white/70 transition-colors text-xs"
                title="Acceso personal autorizado"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span>Staff</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
